import Icon from '../Icon';

// Presentational toast pill (dark, top-center layer).
export default function Toast({ kind, message }) {
  return (
    <div className="toast">
      {kind === 'success' && <span className="toast__icon--success"><Icon name="check" /></span>}
      {kind === 'error' && <span className="toast__icon--error"><Icon name="error-circle" /></span>}
      {kind === 'info' && <span style={{ display: 'flex' }}><Icon name="info" /></span>}
      <span>{message}</span>
    </div>
  );
}
